import React, { useEffect, useState } from 'react'
import { useQueryParams } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import QuickNameReview from './quickNameReview/QuickNameReview'
import FullNameCorrection from './fullNameCorrection/FullNameCorrection'
import FamilyReview from './familyReview/FamilyReview'
import { getTaskList } from '../../shared/services/recordEnhancement/recordEnhancementService'
import FlaggedUserContextProvider from '../../Give/utils/flaggedUserLibrary/FlaggedUserContext'
import ErrorBoundaryFallback from '../../shared/components/errorBoundaryFallback/ErrorBoundaryFallback'
import { errorCollector } from '../../shared/utils/utils'
import FullNameContextProvider from './fullNameCorrection/providers/FullNameContext'
import FamilyReviewContextProvider from './familyReview/providers/FamilyReviewContext'
import OverlayContextProvider from '../../shared/providers/overlayContextProvider/OverlayContext'

function GetNewTask() {
  const [message, setMessage] = useState('')
  const { query } = useQueryParams()

  async function reserveTask() {
    try {
      await getTaskList({
        placeCode: query.placeCode || '158',
        language: 'en',
        isFirstRequest: false,
        taskType: 'Family Review',
        surname: '',
        action: 'EnhanceImageRecords',
      })
      setMessage('Successfully got a task')
    } catch (err) {
      setMessage('Failed to get task: ', err)
    }
  }

  useEffect(() => {
    reserveTask()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div>{message}</div>
}

export default function TaskLoader() {
  const { query } = useQueryParams()
  const { task } = query
  const handleFamilyReviewError = (error, info) => {
    console.error('well, sorry about the bad news', error, info)
    errorCollector(error, null, {
      codeId: 1000,
      status: error?.response?.status,
      responseBody: error?.response?.data,
      ...info,
    })
  }

  return (
    <OverlayContextProvider>
      {task === 'Name Correction' && (
        <FlaggedUserContextProvider>
          <QuickNameReview />
        </FlaggedUserContextProvider>
      )}
      {task === 'Full Name Review' && (
        <FullNameContextProvider>
          <FullNameCorrection />
        </FullNameContextProvider>
      )}
      {task === 'Family Review' && (
        <ErrorBoundary FallbackComponent={ErrorBoundaryFallback} errorHandler={handleFamilyReviewError}>
          <FamilyReviewContextProvider>
            <FamilyReview />
          </FamilyReviewContextProvider>
        </ErrorBoundary>
      )}
      {task === 'Get New Task' && <GetNewTask />}
    </OverlayContextProvider>
  )
}
